import React, { useState } from "react";
import "./FloatingButton.css";
import ReplyIcon from "@mui/icons-material/Reply";
import Tooltip from "@mui/material/Tooltip";
import ScreenShot from "../../images/SupportIcon.svg";
import CloseIcon from "../../images/Close.png";
import tickets from "../../images/tickets.png";
import useScreenRecorder from "../../hooks/useScreenRecorder";
import { IconButton, Popover } from "@mui/material";
import { CameraAlt } from "@mui/icons-material";

const RenderFloatingButton = ({
  showFloatingButton,
  handleReplyClick,
  setIsHovered,
  parentStyle,
  handleClick,
  isOpen,
  handleCross,
  isClicked,
  isHovered
}) => {
  return (
    <>
      {!showFloatingButton ? (
        <Tooltip title="Show Support Icon" placement="top" arrow>
          <div
            className={`replicon ${showFloatingButton ? "rotated" : ""}`}
            onClick={handleReplyClick}
          >
            <ReplyIcon style={{ fontSize: "2rem", color: "grey" }} />
          </div>
        </Tooltip>
      ) : (
        <>
          <div
            className={`floatingButton ${isClicked ? "no-hover" : ""}`}
            style={{ ...parentStyle.customIndex }}
            onMouseEnter={() => {
              return setIsHovered(true);
            }}
            onMouseLeave={() => {
              return setIsHovered(false);
            }}
            onClick={(event) => isHovered && handleClick(event)}
          >
            {isOpen ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  onClick={handleCross}
                  src={CloseIcon}
                  alt="Close"
                  width="30px"
                />
              </div>
            ) : (
              <div className="FloatingIcon">
               <img
                  src={ScreenShot}
                />
              </div>
            )}

            <div className="floatingButtonText">Report An Issue</div>
          </div>
          <div
            className={`replicon ${showFloatingButton ? "rotated" : ""}`}
            onClick={handleReplyClick}
          >
            <Tooltip title="Hide Support Icon" placement="top" arrow>
              <ReplyIcon style={{ fontSize: "2rem", color: "grey" }} />
            </Tooltip>
          </div>
        </>
      )}
    </>
  );
};

const RenderSimpleButton = ({handleClick, supportBtnRef}) => {
  return (
    <IconButton ref={supportBtnRef} sx={{padding: "4px"}} onClick={handleClick} >
      <CameraAlt sx={{fontSize: "1.5rem"}} />
    </IconButton>
  );
};

const FloatingButton = ({
  setType,
  handleRecordFlow,
  setShowRecordModal,
  parentStyle,
  setSelect,
  isInsideChatbot,
  setIsBotHidden,
  supportBtnRef
}) => {
  const { setStatus } = useScreenRecorder({ audio: true });

  const [isOpen, setIsOpen] = useState(false);
  const [showFloatingButton, setShowFloatingButton] = useState(true);
  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleReplyClick = (e) => {
    setIsOpen(false);
    setShowFloatingButton((prev) => {
      return !prev;
    });
    setIsClicked(false);
  };

  const handleButtonClick = () => {
    if(isInsideChatbot) {
      setIsBotHidden(true);
    }
    if (isOpen) {
      setType("shotType");
      setIsOpen(false);
      setSelect(true);
    } else {
      setType("none");
      setIsOpen(true);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (isOpen) {
      setIsOpen(false);
      setSelect(true);
      setShowFloatingButton(false);
    } else {
      setType("none");
      setIsOpen(true);
    }
    setIsClicked(true);
  };

  const handleRecordClick = () => {
    if(isInsideChatbot) {
      setIsBotHidden(true);
    }
    setIsOpen(false);
    setStatus("permission-required");
    setShowRecordModal(true);
    handleRecordFlow();
    setSelect(false);
    setShowFloatingButton(false);
  };

  const handleCross = () => {
    setType("none");
    setIsOpen(false);
    setShowFloatingButton(true);
    setIsClicked(false);
  };

  return (
    <div
      className={!isInsideChatbot ? 'floatingButtonContainer' : ''}
      style={{ ...parentStyle.customIndex }}
    >
      {isInsideChatbot ? (
        <RenderSimpleButton handleClick={handleClick} supportBtnRef={supportBtnRef} />
      ) : (
        <RenderFloatingButton
          showFloatingButton={showFloatingButton}
          handleReplyClick={handleReplyClick}
          setIsHovered={setIsHovered}
          parentStyle={parentStyle}
          handleClick={handleClick}
          isOpen={isOpen}
          handleCross={handleCross}
          isClicked={isClicked}
          isHovered={isHovered}
        />
      )}

      <Popover
        open={isOpen}
        onClose={handleCross}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{zIndex: parentStyle.customIndex.zIndex + 10}}
        slotProps={{
          paper: {
            sx: {
              marginTop: -4,
              marginLeft: -4,
              zIndex: parentStyle.customIndex.zIndex + 10
            },
          },
        }}
      >
        <div className="FloatingModal" style={{ ...parentStyle.customIndex }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  marginTop: "16px",
                  fontSize: "16px",
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                Facing Problem?
              </div>
              <div style={{ fontSize: "14px", textAlign: "left" }}>
                Our web support team is here to help! Feel free to reach out to
                with any question or issues you're facing while navigating our
                website.
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                Report an issue
              </div>
            </div>
            <div>
              <img
                src={tickets}
                style={{ width: "155px", height: "155px" }}
                alt=""
              />
            </div>
          </div>
          <div style={{ paddingRight: "32px" }}>
            <button
              style={{
                cursor: "pointer",
                fontSize: "14px",
                color: "white",
                width: "100%",
                margin: "16px 0px 0px 0px ",
                borderRadius: "8px",
                textAlign: "center",
                padding: "8px",
                backgroundColor: "#0F4C81",
                border: "none",
              }}
              onClick={handleButtonClick}
            >
              Take A Screenshot
            </button>
            <button
              style={{
                cursor: "pointer",
                fontSize: "14px",
                color: "white",
                width: "100%",
                margin: "16px 0px 0px 0px ",
                borderRadius: "8px",
                textAlign: "center",
                padding: "8px",
                backgroundColor: "#0F4C81",
                border: "none"
              }}
              onClick={handleRecordClick}
            >
              Record A Video
            </button>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default FloatingButton;
